export default {"src":"/_next/static/media/languageIcon.10a66bfb.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};